import { slideToggle } from 'slidetoggle';

export default class Header {
    private selector: HTMLElement;
    private burger: HTMLElement;
    private menu: HTMLElement;
    private langs: HTMLElement;
    private lang: HTMLElement;
    private body: HTMLElement;
    private scrollPosition: number;
    private toggleItems: NodeListOf<HTMLElement>;

    constructor(selector: string) {
        this.body = document.querySelector('body');
        this.selector = document.querySelector(selector);
        this.burger = document.querySelector('[data-burger]');
        this.menu = document.querySelector('[data-menu]');
        this.langs = document.querySelector('[data-langs]');
        this.lang = document.querySelector('[data-current-lang]');
        this.toggleItems = document.querySelectorAll('[data-toggle-menu]');

        if (this.selector) {
            this.init();
        }
    }

    private init(): void {
        window.addEventListener('scroll', this.changeHeader.bind(this));
        window.addEventListener('resize', this.changeHeader.bind(this));

        if (this.burger) {
            this.burger.addEventListener('click', this.openCloseMenu.bind(this));
        }

        if (this.lang) {
            this.lang.addEventListener('click', this.openCloseLangs.bind(this));
        }

        if (this.toggleItems) {
            this.toggleItems.forEach((item: HTMLElement) => {
                item.addEventListener('click', this.toggle.bind(this));
            });
        }
    }

    private openCloseMenu(): void {
        this.burger.classList.toggle('header__menu--active');
        this.menu.classList.toggle('menu--active');
        this.selector.classList.toggle('header--opened');
        this.body.classList.toggle('stop-scrolling');

        if (this.body.classList.contains('stop-scrolling')) {
            this.scrollPosition = window.pageYOffset;
            this.body.style.overflow = 'hidden';
            this.body.style.position = 'fixed';
            this.body.style.top = `-${this.scrollPosition}px`;
            this.body.style.width = '100%';

            setTimeout(() => {
                this.menu.style.height = `${window.innerHeight}px`;
            }, 300);
        } else {
            this.body.style.removeProperty('overflow');
            this.body.style.removeProperty('position');
            this.body.style.removeProperty('top');
            this.body.style.removeProperty('width');
            window.scrollTo(0, this.scrollPosition);
        }
    }

    private openCloseLangs(): void {
        this.langs.classList.toggle('menu__langs--active');
    }

    private changeHeader(): void {
        const scroll: number = window.pageYOffset;
        if (scroll > 0) {
            this.selector.classList.add('header--scrolled');
        } else {
            this.selector.classList.remove('header--scrolled');
        }
    }

    private toggle(e: Event): void {
        const item = e.target as HTMLElement;
        const parent: HTMLElement = item.closest('[data-submenu-wrap]');
        const submenu: HTMLElement = parent.querySelector('[data-submenu]');

        slideToggle.slideToggle(submenu, 300);
        parent.classList.toggle('menu__submenu-wrap--active');
    }
}
